import { Turnstile } from "@marsidev/react-turnstile";
import { Link } from "react-router";
import { useState } from "react";

import style from "../style/Legal.module.css";

function Legal() {
    const [verified, setVerified] = useState(false);

    return (
        <>
            <title>Legal Notice - Emil Albrecht</title>
            {process.env.NODE_ENV && process.env.NODE_ENV !== "development" && !verified &&
                <Turnstile className={style.turnstile} siteKey="0x4AAAAAABlYMzSixx_b7D-S" onSuccess={() => setVerified(true)} />
            }
            {(verified || process.env.NODE_ENV === "development") && <div className={style.container}>
                <h1 className={style.title}>Legal Notice</h1>

                <Link to={"/"}>Back to Home</Link>

                <hr />

                <h2>
                    Angaben gemäß § 5 TMG und verantwortlich im Sinne des § 55 Abs. 2 RStV:
                </h2>

                <ul>
                    <li>Emil Albrecht</li>
                    <li>Lenbachstr. 10</li>
                    <li>79618 Rheinfelden</li>
                </ul>

                <h3>Kontakt:</h3>

                <ul>
                    <li>E-Mail: emil@albrecht.eco</li>
                </ul>

                <hr />

                <h2>Datenschutzerklärung</h2>

                <p>Diese Website dient ausschließlich der persönlichen Präsentation von Emil Frederik Albrecht.</p>
                <p>Beim Besuch dieser Website werden keine personenbezogenen Daten erfasst, gespeichert oder verarbeitet.</p>
                <p>Es werden keine Cookies gesetzt und keine Analyse- oder Trackingdienste (wie Google Analytics) verwendet.</p>

                <h3>Externe Links</h3>

                <p>Diese Website enthält Links zu externen Websites (z. B. GitHub). Beim Klicken auf diese Links verlassen Sie diese Website. Für die Inhalte und den Datenschutz der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.</p>

                <p>Stand: Juli 2025</p>

                <hr />

                <h2>Privacy Policy</h2>
                <p>This website is solely intended for the personal presentation of Emil Frederik Albrecht.</p>
                <p>No personal data is collected, stored, or processed when visiting this website.</p>
                <p>No cookies are set, and no analytics or tracking tools (such as Google Analytics) are used.</p>

                <h3>External Links</h3>
                <p>This website contains links to external websites (e.g., GitHub). By clicking on such links, you leave this website. The respective operators of those external sites are solely responsible for their content and data protection practices.</p>

                <p>Last updated: July 2025</p>

            </div>}
        </>
    );
}

export default Legal;